module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order",
    style: (_vm.bannerFlag ? 'margin-top: 56px;' : '')
  }, [_c('div', {
    staticClass: "order-box w",
    staticStyle: {
      "min-height": "calc(100vh - 125px)"
    }
  }, [_c('div', {
    staticClass: "order-step"
  }, _vm._l((_vm.stepList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "order-step-wrap",
      class: item.stepList.includes(_vm.currentStep + '') ? 'step-active' : ''
    }, [_c('i', {
      class: item.icon,
      staticStyle: {
        "font-size": "18px"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "min-height": "calc(100vh - 220px)"
    },
    attrs: {
      "element-loading-text": "加载中...",
      "element-loading-background": "rgba(0, 0, 0, 0)"
    }
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n        " + _vm._s(_vm.form.demName) + " " + _vm._s(_vm.catalogTitle) + " "), (_vm.currentStep != 1 && _vm.form.demPatient) ? _c('span', [_vm._v("【" + _vm._s(_vm.form.demPatient) + "】")]) : _vm._e()]), _vm._v(" "), (_vm.currentStep === 1) ? _c('div', {
    staticClass: "order-detail-catalog",
    staticStyle: {
      "min-height": "calc(100vh - 313px)"
    }
  }, [_c('section', {
    staticClass: "order-catalog"
  }, [_c('ul', {
    staticClass: "box"
  }, _vm._l((_vm.catalogList), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "content",
      class: _vm.currentCatalog === i ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.changeMainCatalog(i)
        }
      }
    }, [(_vm.currentCatalog === i) ? _c('img', {
      staticClass: "i",
      attrs: {
        "src": item.iconSelect
      }
    }) : _c('img', {
      staticClass: "i",
      attrs: {
        "src": item.icon
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('a', {
      staticClass: "cover-link"
    })])
  }), 0)]), _vm._v(" "), _c('section', {
    staticClass: "order-sub-catalog"
  }, [_c('ul', {
    staticClass: "box"
  }, _vm._l((_vm.subCatalogList), function(item, j) {
    return _c('li', {
      key: j,
      staticClass: "content",
      class: _vm.currentSubCatalog === j ? 'active' : '',
      attrs: {
        "id": _vm.currentCatalog == 0 && _vm.user.demServType != '00' ? 'clinic' : 'factory'
      },
      on: {
        "click": function($event) {
          return _vm.changeSubCatalog(j)
        }
      }
    }, [_c('div', {
      staticClass: "sub-box"
    }, [_c('img', {
      staticClass: "i",
      attrs: {
        "src": item.icon
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('a', {
      staticClass: "cover-link"
    })])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.currentStep === 2 && _vm.subCatalogId != '3010130') ? _c('div', {
    staticClass: "order-detail-design",
    staticStyle: {
      "min-height": "calc(100vh - 313px)"
    }
  }, [_c('div', {
    ref: "tooth",
    staticClass: "order-design-image",
    staticStyle: {
      "margin-top": "30px",
      "background-color": "#F7F7F7"
    }
  }, [_c('DTooth', {
    ref: "toothComponent",
    staticStyle: {
      "margin-left": "-10px",
      "padding-bottom": "50px"
    },
    attrs: {
      "adjunct": _vm.adjunct,
      "teethList": _vm.teethList,
      "steelList": _vm.steelList,
      "glueList": _vm.glueList
    },
    on: {
      "changeTooth": _vm.changeOrderCount
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-design-info"
  }, [_c('div', {
    staticClass: "order-basic-wrap"
  }, [_c('base-tag', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label": "基本信息"
    }
  }), _vm._v(" "), _c('input-field', {
    attrs: {
      "inputClass": "contact",
      "label": '下单名称',
      "customStyle": {
        '--inputColorContact': _vm.colorContact
      },
      "readonly": _vm.user.demServType == '00' ? true : false,
      "required": ""
    },
    on: {
      "input": _vm.change1
    },
    model: {
      value: (_vm.form.demContact),
      callback: function($$v) {
        _vm.$set(_vm.form, "demContact", $$v)
      },
      expression: "form.demContact"
    }
  }), _vm._v(" "), _c('input-field', {
    attrs: {
      "inputClass": "phone",
      "label": "联系方式",
      "customStyle": {
        '--inputColorPhone': _vm.colorPhone
      },
      "readonly": false,
      "required": ""
    },
    on: {
      "input": _vm.change2
    },
    model: {
      value: (_vm.form.demPhone),
      callback: function($$v) {
        _vm.$set(_vm.form, "demPhone", $$v)
      },
      expression: "form.demPhone"
    }
  }), _vm._v(" "), _c('input-field', {
    attrs: {
      "inputClass": "patient",
      "label": "患者姓名",
      "customStyle": {
        '--inputColorPatient': _vm.colorPatient
      },
      "readonly": false,
      "required": ""
    },
    on: {
      "input": _vm.change3
    },
    model: {
      value: (_vm.form.demPatient),
      callback: function($$v) {
        _vm.$set(_vm.form, "demPatient", $$v)
      },
      expression: "form.demPatient"
    }
  }), _vm._v(" "), _c('select-field', {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      "label": "患者性别",
      "options": _vm.demSexMap,
      "placeholder": "请选择性别",
      "required": ""
    },
    model: {
      value: (_vm.form.demSex),
      callback: function($$v) {
        _vm.$set(_vm.form, "demSex", $$v)
      },
      expression: "form.demSex"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "设计费详情"
    }
  }), _vm._v(" "), _c('input-field', {
    attrs: {
      "label": "数量",
      "readonly": true,
      "required": ""
    },
    model: {
      value: (_vm.form.orderCount),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderCount", $$v)
      },
      expression: "form.orderCount"
    }
  }), _vm._v(" "), _c('input-field', {
    attrs: {
      "label": "单价",
      "readonly": true,
      "required": ""
    },
    model: {
      value: (_vm.form.orderPrice),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderPrice", $$v)
      },
      expression: "form.orderPrice"
    }
  }), _vm._v(" "), (_vm.form.steelCount > 0) ? _c('input-field', {
    attrs: {
      "label": "钢牙数量",
      "readonly": true,
      "required": ""
    },
    model: {
      value: (_vm.form.steelCount),
      callback: function($$v) {
        _vm.$set(_vm.form, "steelCount", $$v)
      },
      expression: "form.steelCount"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.steelCount > 0) ? _c('input-field', {
    attrs: {
      "label": "钢牙单价",
      "readonly": true,
      "required": ""
    },
    model: {
      value: (_vm.form.steelPrice),
      callback: function($$v) {
        _vm.$set(_vm.form, "steelPrice", $$v)
      },
      expression: "form.steelPrice"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.glueCount > 0) ? _c('input-field', {
    attrs: {
      "label": "充胶牙数量",
      "readonly": true,
      "required": ""
    },
    model: {
      value: (_vm.form.glueCount),
      callback: function($$v) {
        _vm.$set(_vm.form, "glueCount", $$v)
      },
      expression: "form.glueCount"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.glueCount > 0) ? _c('input-field', {
    attrs: {
      "label": "充胶牙单价",
      "readonly": true,
      "required": ""
    },
    model: {
      value: (_vm.form.gluePrice),
      callback: function($$v) {
        _vm.$set(_vm.form, "gluePrice", $$v)
      },
      expression: "form.gluePrice"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.enclosure != '') ? _c('input-field', {
    attrs: {
      "label": "精密附件数量",
      "readonly": true,
      "required": ""
    },
    model: {
      value: (_vm.form.enclosureCount),
      callback: function($$v) {
        _vm.$set(_vm.form, "enclosureCount", $$v)
      },
      expression: "form.enclosureCount"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.enclosure != '') ? _c('input-field', {
    attrs: {
      "label": "精密附件单价",
      "readonly": true,
      "required": ""
    },
    model: {
      value: (_vm.form.enclosurePrice),
      callback: function($$v) {
        _vm.$set(_vm.form, "enclosurePrice", $$v)
      },
      expression: "form.enclosurePrice"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLevel) ? _c('select-field', {
    attrs: {
      "label": "设计师级别",
      "options": _vm.desLevelMap,
      "placeholder": "请选择设计师级别"
    },
    on: {
      "input": _vm.calAmount
    },
    model: {
      value: (_vm.form.desLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "desLevel", $$v)
      },
      expression: "form.desLevel"
    }
  }) : _vm._e(), _vm._v(" "), _c('input-number-field', {
    attrs: {
      "label": "是否加急(元)",
      "disabled": _vm.isEditServOrder == '1',
      "isEditServOrder": _vm.isEditServOrder,
      "required": ""
    },
    on: {
      "input": _vm.calAmount
    },
    model: {
      value: (_vm.form.orderRushFee),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderRushFee", $$v)
      },
      expression: "form.orderRushFee"
    }
  }), _vm._v(" "), _c('input-field', {
    staticStyle: {
      "margin-top": "-5px"
    },
    attrs: {
      "label": "总价",
      "readonly": true,
      "required": ""
    },
    model: {
      value: (_vm.form.orderAmount),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderAmount", $$v)
      },
      expression: "form.orderAmount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "设计需求"
    }
  }), _vm._v(" "), (['4010120'].includes(_vm.subCatalogId)) ? _c('select-field', {
    attrs: {
      "label": "下单类型",
      "options": _vm.annexMap,
      "placeholder": "请选择设计类型",
      "required": ""
    },
    on: {
      "change": _vm.changeDesignTray
    },
    model: {
      value: (_vm.form.designTray),
      callback: function($$v) {
        _vm.$set(_vm.form, "designTray", $$v)
      },
      expression: "form.designTray"
    }
  }) : _vm._e(), _vm._v(" "), (['4010110'].includes(_vm.subCatalogId)) ? _c('div', {
    staticClass: "input-form-wrap",
    staticStyle: {
      "margin-left": "3.5%",
      "width": "47%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('el-input', {
    staticClass: "input-form",
    staticStyle: {
      "margin-left": "3.5%"
    },
    attrs: {
      "size": "mini",
      "placeholder": "选填"
    },
    on: {
      "input": _vm.changeAnnex
    },
    model: {
      value: (_vm.form.enclosure),
      callback: function($$v) {
        _vm.$set(_vm.form, "enclosure", $$v)
      },
      expression: "form.enclosure"
    }
  })], 1) : _vm._e(), _vm._v(" "), (['4010110'].includes(_vm.subCatalogId)) ? _c('div', {
    staticClass: "input-form-wrap",
    staticStyle: {
      "width": "56%",
      "margin": "2% 0 0 20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "margin-left": "-30px"
    },
    attrs: {
      "label": "00"
    },
    model: {
      value: (_vm.adjunct),
      callback: function($$v) {
        _vm.adjunct = $$v
      },
      expression: "adjunct"
    }
  }, [_vm._v("无附件")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "01"
    },
    model: {
      value: (_vm.adjunct),
      callback: function($$v) {
        _vm.adjunct = $$v
      },
      expression: "adjunct"
    }
  }, [_vm._v("钢牙")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "02"
    },
    model: {
      value: (_vm.adjunct),
      callback: function($$v) {
        _vm.adjunct = $$v
      },
      expression: "adjunct"
    }
  }, [_vm._v("充胶牙")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    style: (_vm.subCatalogId == '4010110' ? 'margin-top: 5px;' : 'margin-top: 10px;')
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px",
      "margin-left": "27px"
    },
    attrs: {
      "type": "primary",
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": _vm.resetTeeth
    }
  }, [_vm._v("重置牙位")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px",
      "margin-left": "27px"
    },
    attrs: {
      "type": "primary",
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": _vm.undoTeeth
    }
  }, [_vm._v("撤销")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "备注信息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-textarea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 20
      },
      "placeholder": "请输入备注信息"
    },
    model: {
      value: (_vm.form.orderRemark),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderRemark", $$v)
      },
      expression: "form.orderRemark"
    }
  })], 1)], 1), _vm._v(" "), (_vm.remarkHistory.length != 0) ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "快捷标签"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-history"
  }, _vm._l((_vm.remarkHistory), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticStyle: {
        "margin": "5px 5px"
      },
      attrs: {
        "closable": ""
      },
      on: {
        "click": function($event) {
          return _vm.replaceStr(index)
        },
        "close": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.currentStep === 3) ? _c('div', {
    staticClass: "order-detail-upload",
    staticStyle: {
      "min-height": "calc(100vh - 313px)"
    }
  }, [(!_vm.editCanvas) ? _c('el-button', {
    staticStyle: {
      "width": "120px",
      "margin-left": "44%"
    },
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "mini"
    },
    on: {
      "click": _vm.changeEdit
    }
  }, [_vm._v("重新编辑")]) : _vm._e(), _vm._v(" "), (_vm.editCanvas) ? _c('canvasBracket', {
    attrs: {
      "canvasImgUrl": _vm.canvasImgUrl
    },
    on: {
      "canvasImg": _vm.canvasToothImg,
      "ruleFlag": _vm.corrective
    }
  }) : _c('img', {
    staticStyle: {
      "width": "570px",
      "height": "620px",
      "margin-left": "25%"
    },
    attrs: {
      "src": _vm.designActiveImg
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentStep === 4) ? _c('div', {
    staticClass: "order-detail-upload",
    staticStyle: {
      "min-height": "calc(100vh - 313px)"
    }
  }, [(_vm.common.serv.get(_vm.subCatalogId).isDataType == '1' || _vm.common.serv.get(_vm.subCatalogId).isSoftType == '1') ? _c('div', {
    staticClass: "input-type-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "数据信息"
    }
  }), _vm._v(" "), (_vm.common.serv.get(_vm.subCatalogId).isDataType == '1') ? _c('div', {
    staticClass: "input-form-wrap"
  }, [_vm._m(2), _vm._v(" "), _c('el-select', {
    staticClass: "input-select",
    attrs: {
      "placeholder": "请选择数据类型",
      "size": "mini"
    },
    model: {
      value: (_vm.form.dataType),
      callback: function($$v) {
        _vm.$set(_vm.form, "dataType", $$v)
      },
      expression: "form.dataType"
    }
  }, _vm._l((_vm.common.dict.get('biz_scan_type')), function(item) {
    return _c('el-option', {
      key: item.value,
      staticClass: "option-item",
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.form.dataType == '99') ? _c('div', [_c('el-input', {
    staticClass: "input-form",
    attrs: {
      "placeholder": "请输入数据类型",
      "size": "mini"
    },
    model: {
      value: (_vm.form.otherDataType),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherDataType", $$v)
      },
      expression: "form.otherDataType"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.subCatalogId).isSoftType == '1') ? _c('div', {
    staticClass: "input-form-wrap"
  }, [_vm._m(3), _vm._v(" "), _c('el-select', {
    staticClass: "input-select",
    attrs: {
      "placeholder": "请选择软件种类",
      "size": "mini"
    },
    model: {
      value: (_vm.form.softType),
      callback: function($$v) {
        _vm.$set(_vm.form, "softType", $$v)
      },
      expression: "form.softType"
    }
  }, _vm._l((_vm.common.dict.get('biz_soft_type')), function(item) {
    return _c('el-option', {
      key: item.value,
      staticClass: "option-item",
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.form.softType == '99') ? _c('div', [_c('el-input', {
    staticClass: "input-form",
    attrs: {
      "placeholder": "请输入扫描仪品牌",
      "size": "mini"
    },
    model: {
      value: (_vm.form.otherSoftType),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherSoftType", $$v)
      },
      expression: "form.otherSoftType"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.subCatalogId).isScanData == '1') ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "扫描数据"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "order-upload-wrap"
  }, [_c('div', {
    staticClass: "order-file-wrap"
  }, [_c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "before-upload": _vm.handleChange,
      "http-request": _vm.uploadFile,
      "before-remove": _vm.beforeRemove,
      "on-remove": function (file, fileList) {
        _vm.handleRemove(file, fileList, '07')
      },
      "data": {
        objectType: '07',
        objectTag: _vm.subCatalogId + '_' + _vm.form.demPatient
      },
      "file-list": _vm.dataScan,
      "on-exceed": _vm.handleExceed,
      "auto-upload": true,
      "limit": 5,
      "multiple": ""
    }
  }, [_c('div', {
    staticClass: "upload-file-dragger1"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.form.enclosure.length > 0) ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "精密配件数据库"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "order-upload-wrap"
  }, [_c('div', {
    staticClass: "order-file-wrap"
  }, [_c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "before-upload": _vm.handleChange,
      "http-request": _vm.uploadFile,
      "before-remove": _vm.beforeRemove,
      "on-remove": function (file, fileList) {
        _vm.handleRemove(file, fileList, '22')
      },
      "data": {
        objectType: '22',
        objectTag: _vm.subCatalogId + '_' + _vm.form.demPatient
      },
      "file-list": _vm.dataAccessory,
      "on-exceed": _vm.handleExceed,
      "auto-upload": true,
      "limit": 5,
      "multiple": ""
    }
  }, [_c('div', {
    staticClass: "upload-file-dragger1"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])])], 1)])], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-ops"
  }, [(_vm.currentStep === 2) ? _c('y-button', {
    attrs: {
      "text": "重新创建",
      "classStyle": "main-btn ml"
    },
    on: {
      "btnClick": _vm.clickReSelect
    }
  }) : _vm._e(), _vm._v(" "), ([3, 4].includes(_vm.currentStep)) ? _c('y-button', {
    attrs: {
      "text": "上一步",
      "classStyle": "main-btn ml"
    },
    on: {
      "btnClick": _vm.clickPreStep
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep != 4) ? _c('y-button', {
    attrs: {
      "text": "下一步",
      "classStyle": _vm.nextStep ? 'main-btn ml' : 'disabled-btn ml'
    },
    on: {
      "btnClick": _vm.clickNextStep
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEditServOrder == '1' || _vm.currentStep == 4) ? _c('y-button', {
    attrs: {
      "text": _vm.isEditServOrder == '1' ? '修改提交' : '生成订单',
      "classStyle": "main-btn ml"
    },
    on: {
      "btnClick": _vm.submitUpdate
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('Customer', {
    staticClass: "customerSer"
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": "",
      "title": "进度留言",
      "width": "30%",
      "visible": _vm.msgDialog,
      "modal-append-to-body": false,
      "destroy-on-close": true,
      "lock-scroll": false
    },
    on: {
      "update:visible": function($event) {
        _vm.msgDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "left",
      "model": _vm.ruleForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "content",
      "label": "留言内容:",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 8
      },
      "placeholder": "请填写留言内容内容"
    },
    model: {
      value: (_vm.ruleForm.content),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "content", $$v)
      },
      expression: "ruleForm.content"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.msgDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("继续制作")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("精密附件：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("附件")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("数据类型")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("扫描仪品牌")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24ae2074","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/activeModification/orderCreateBracket.vue
// module id = 625
// module chunks = 0